export const PRODUCT_TYPE_SIMPLE = 1;
export const PRODUCT_TYPE_COMPOSITE = 9;
export const PRODUCT_TYPE_RODIZIO = 10; // Tipo rodízio (produto pai do qual o composto deriva)

export const VIEW_MODE_GRID = 'grid';
export const VIEW_MODE_IMAGE_GALLERY = 'swiper_image';
export const VIEW_MODE_LIST = 'list';
export const initialViewMode = VIEW_MODE_GRID;

export const PRODUCT_NOT_ACTIVE = 'product_not_active';

//* fake list products for Skeleton
const isMobile = window.innerWidth <= 768;
export const dataFakeForLoading = [
    {id: 1, layout: isMobile ? VIEW_MODE_IMAGE_GALLERY : VIEW_MODE_LIST, products: [{id: 1}, {id: 2}, {id: 3}, {id: 4}, {id: 5}, {id: 6}, {id: 7}, {id: 8}, {id: 9}, {id: 10}]},
    {id: 2, products: [{id: 1}, {id: 2}, {id: 3}, {id: 4}, {id: 5}, {id: 6}, {id: 7}, {id: 8}, {id: 9}, {id: 10}]},
    {id: 3, products: [{id: 1}, {id: 2}, {id: 3}, {id: 4}, {id: 5}, {id: 6}, {id: 7}, {id: 8}, {id: 9}, {id: 10}]},
    {id: 4, products: [{id: 1}, {id: 2}, {id: 3}, {id: 4}, {id: 5}, {id: 6}, {id: 7}, {id: 8}, {id: 9}, {id: 10}]},
    {id: 5, products: [{id: 1}, {id: 2}, {id: 3}, {id: 4}, {id: 5}, {id: 6}, {id: 7}, {id: 8}, {id: 9}, {id: 10}]},
    {id: 6, products: [{id: 1}, {id: 2}, {id: 3}, {id: 4}, {id: 5}, {id: 6}, {id: 7}, {id: 8}, {id: 9}, {id: 10}]}
]

